module.exports = new __parcel__URL__("check.8bdb7ed6.svg").toString();